import React from "react";
import "../../App.css";
import ServicePage from "../ServicePage";

export default function Services() {
  return (
    <>
      <div className="services">
        <ServicePage />
      </div>
    </>
  );
}
